export default __webpack_public_path__ + "static/media/Rish Rao.027cfdfb.jpg";